 import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';

import Sidebar from './Component/Sidebar';
import Login from './Pages/Login';
import Dashboard from './Pages/Dashboard';
import Master from './Pages/Master';
import VendorUsers from './Pages/Vendorusers';
import VendorTeam from './Pages/VendorTeam';
import WaitForQC from './Pages/WaitForQC';
import EditQC from "./Pages/EditQC";
import QcFinished from "./Pages/QcFinished";
import GrnPending from "./Pages/GrnPending";
import QcFinishedDetail from "./Pages/QcFinishedDetail";
import DatabaseKeyPage from "./Pages/DatabaseKeyPage";
import Inspectionreport from "./Pages/Inspectionreport";

import './index.css';

function LayoutWrapper() {
  const location = useLocation();

  // Routes where Sidebar is hidden (e.g. login page, database key page)
  const hideSidebarRoutes = ['/', '/login', '/database-key'];

  // Also hide sidebar for EditQC view-only mode
  const isEditQcViewOnly = location.pathname.startsWith('/editqc/') && location.search.includes('view=true');

  const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname) || isEditQcViewOnly;

  return (
    <div className="flex min-h-screen">
      {!shouldHideSidebar && <Sidebar />}
      <div className="flex-1 p-4 bg-gray-50">
        <Routes>
          {/* First Page: Database Key */}
          <Route path="/" element={<DatabaseKeyPage />} />
          <Route path="/database-key" element={<DatabaseKeyPage />} />

          {/* Login Page */}
          <Route path="/login" element={<Login />} />

          {/* Other Pages */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/master" element={<Master />} />
          <Route path="/vendorusers" element={<VendorUsers />} />
          <Route path="/VendorTeam" element={<VendorTeam />} />
          <Route path="/waitforqc" element={<WaitForQC />} />
          <Route path="/QcFinished" element={<QcFinished />} />
          <Route path="/editqc/:id" element={<EditQC />} />
          <Route path="/qc-finished-detail" element={<QcFinishedDetail />} />
          <Route path="/GrnPending" element={<GrnPending />} />
          <Route path="/InspectionReport" element={<Inspectionreport />} />


          {/* Redirect unknown routes */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <LayoutWrapper />
    </Router>
  );
}
